// Icons
import {
  TreeEvergreen,
  Moon,
  ArrowRight,
  List,
  X,
  ArrowLeft,
} from "phosphor-react";

// Other
import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const GuestNavbar = (props) => {
  const [navState, setNavState] = useState(false);

  return (
    <nav className="h-16 desktop:fixed desktop:w-8/12 tablet:w-11/12 mobile:w-11/12 flex justify-between font-brand items-center bg-dark-700 z-10 mobile:text-center">
      {/* Left Section */}
      <Link to="/redirect" className="flex items-center font-bold z-20">
        {/* Brand Icon */}
        <TreeEvergreen
          size={30}
          color="#009fff"
          weight="bold"
          className="mr-1.5"
        />
        <span>Mirelise</span>
      </Link>

      {/* Right Section */}
      <ul
        className={
          "flex items-center tablet:space-x-8 > * + * mobile:space-y-3 > * + * font-semibold mobile:absolute mobile:inset-0 mobile:w-screen mobile:h-screen mobile:justify-center mobile:text-center mobile:flex-col mobile:bg-dark-700 z-10 mobile:" +
          (navState ? "visible" : "hidden")
        }
      >
        {props.page === "landing-page" ? (
          <>
            <li
              onClick={() => {
                setNavState(!navState);
              }}
            >
              Discover
            </li>

            <li
              onClick={() => {
                setNavState(!navState);
              }}
            >
              FAQs
            </li>

            <li
              onClick={() => {
                setNavState(!navState);
              }}
            >
              Contact
            </li>
          </>
        ) : (
          <></>
        )}

        {/* Theme Toggle */}
        <Moon
          size={25}
          color="#009fff"
          weight="bold"
          className="cursor-pointer"
        />

        {/* Vertical Line */}
        <div className="h-7 border-l mobile:hidden border-dark-500"></div>

        {props.page === "landing-page" ? (
          <>
            <Link
              to="/login"
              onClick={() => {
                setNavState(!navState);
              }}
            >
              Login
            </Link>

            <Link
              to="/signup"
              className="flex py-1.5 px-4 rounded text-white bg-brand-500 hover:bg-brand-700 cursor-pointer"
              onClick={() => {
                setNavState(!navState);
              }}
            >
              <span>Sign up</span>
              <ArrowRight
                size={25}
                color="#fff"
                weight="bold"
                className="ml-1"
              />
            </Link>
          </>
        ) : (
          <>
            <Link
              to="/"
              className="flex py-1.5 px-4 rounded text-white bg-brand-500 hover:bg-brand-700 cursor-pointer"
              onClick={() => {
                setNavState(!navState);
              }}
            >
              <ArrowLeft
                size={25}
                color="#fff"
                weight="bold"
                className="mr-1"
              />
              <span>Back</span>
            </Link>
          </>
        )}
      </ul>
      <section
        className="tablet:hidden mobile:visible z-10"
        onClick={() => {
          setNavState(!navState);
        }}
      >
        {navState ? <X size={25} /> : <List size={25} />}
      </section>
    </nav>
  );
};

export default GuestNavbar;
